import React from 'react';

// Lazy load components to reduce initial bundle size
export const EthUnitConversion = React.lazy(() => import('./components/EthUnitConversion'));
export const TokenUnitConversion = React.lazy(() => import('./components/TokenUnitConversion'));
export const UnixEpochConversion = React.lazy(() => import('./components/UnixEpochConversion'));
export const BaseConversion = React.lazy(() => import('./components/BaseConversion'));
export const StringBytes32Conversion = React.lazy(() => import('./components/StringBytes32Conversion'));
export const CalldataDecoder = React.lazy(() => import('./components/CalldataDecoder'));
export const EventDecoder = React.lazy(() => import('./components/EventDecoder'));
export const ConstructorEncoder = React.lazy(() => import('./components/ConstructorEncoder'));
export const VanityAddressGenerator = React.lazy(() => import('./components/VanityAddressGenerator'));
export const UuidGenerator = React.lazy(() => import('./components/UuidGenerator'));
export const JwtDecoder = React.lazy(() => import('./components/JwtDecoder'));
export const JsonFormatter = React.lazy(() => import('./components/JsonFormatter'));
export const HashGenerator = React.lazy(() => import('./components/HashGenerator'));
export const RandomTextGenerator = React.lazy(() => import('./components/RandomTextGenerator'));
export const UrlEncoder = React.lazy(() => import('./components/UrlEncoder'));
export const QrCodeGenerator = React.lazy(() => import('./components/QrCodeGenerator'));
export const RandomDataGenerator = React.lazy(() => import('./components/RandomDataGenerator'));
export const MinifierBeautifier = React.lazy(() => import('./components/MinifierBeautifier'));
export const RegexTester = React.lazy(() => import('./components/RegexTester'));
export const HttpRequestBuilder = React.lazy(() => import('./components/HttpRequestBuilder'));
export const ColorPicker = React.lazy(() => import('./components/ColorPicker'));
export const ClipboardInspector = React.lazy(() => import('./components/ClipboardInspector'));
export const ComingSoon = React.lazy(() => import('./components/ComingSoon'));
export const EmojiPicker = React.lazy(() => import('./components/EmojiPicker'));
export const TransactionDecoder = React.lazy(() => import('./components/TransactionDecoder'));
export const EthereumBlockTimeConverter = React.lazy(() => import('./components/EthereumBlockTimeConverter'));
export const GasPriceTracker = React.lazy(() => import('./components/GasPriceTracker'));
export const ContractSecurityScanner = React.lazy(() => import('./components/ContractSecurityScanner'));
export const EnsLookup = React.lazy(() => import('./components/EnsLookup'));
export const AddressValidator = React.lazy(() => import('./components/AddressValidator'));
export const AbiEncoderDecoder = React.lazy(() => import('./components/AbiEncoderDecoder'));
export const ContractVerificationHelper = React.lazy(() => import('./components/ContractVerificationHelper'));
export const ContractReadWriteUI = React.lazy(() => import('./components/ContractReadWriteUI'));
export const BalanceChecker = React.lazy(() => import('./components/BalanceChecker'));
export const MevBotBuilder = React.lazy(() => import('./components/MevBotBuilder'));
export const HomePage = React.lazy(() => import('./components/HomePage'));
export const NotFoundPage = React.lazy(() => import('./components/NotFoundPage'));

// Loading component for Suspense fallback
export const LoadingSpinner: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '200px',
    width: '100%'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ 
        width: '40px', 
        height: '40px', 
        border: '4px solid #f3f3f3', 
        borderTop: '4px solid #3498db', 
        borderRadius: '50%', 
        animation: 'spin 1s linear infinite',
        margin: '0 auto 16px'
      }}></div>
      <div>Loading tool...</div>
    </div>
  </div>
); 